/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2021 - 2021
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

export const accessTokenRequest = {
  scopes: [window.env.AADB2C_CLIENT_ID],
  redirectUri: window.env.AADB2C_REDIRECT_URI + "/blank",
};

export const idTokenRequest = {
  scopes: ["openid", "offline_access", ...accessTokenRequest.scopes],
};

export const policyNames = {
  emailSignIn: "B2C_1_SignIn",
  resetPassword: "B2C_1_ResetPassword",
};

export const policyAuthorities = {
  emailSignIn: `${window.env.AADB2C_AUTHORITY_BASE_URI}/${policyNames.emailSignIn}`,
  resetPassword: `${window.env.AADB2C_AUTHORITY_BASE_URI}/${policyNames.resetPassword}`,
};
